import { UserModel } from '../../AccountPage/models/UserModel'

export class LicensesParametersModel {
  pageNumber = 0
  pageSize = 0
  totalItemsCount = 0
}

export class LicensesCollectionVersionModel {
  id = ''
  name = ''
}

export class LicensesCollectionTransactionModel {
  userEmail = ''
  usedDiscountCode = ''
  transactionDate = ''
  createdByDg = false
}

export class LicensesProductModel {
  id = ''
  name = ''
  deleted = false
}

export enum StateIdModel {
  ACTIVE = 'active',
  EXPIRED = 'expired',
  CREATION = 'creation',
  CREATED = 'created',
  SUCCESS = 'success',
}

export class CustomerModel {
  customerName?: string = ''
  customerSurname?: string = ''
  customerFarm?: string = ''
  countryCode?: string = ''
  customerPhone?: string = ''
  customerAddress?: string = ''
  customerEmail?: string = ''
  note?: string = ''
}

export class LicensesCollectionModel extends CustomerModel {
  activationDate: Date | string = ''
  companyCode = ''
  deleted = false
  expirationDate: Date | string = ''
  id = ''
  name = ''
  product = ''
  productId = ''
  reseller = ''
  resellerId = ''
  sequentialId = ''
  serialNumber = ''
  stateId: StateIdModel = StateIdModel.CREATION
  user: UserModel | null = null
  userId = ''
  version: LicensesCollectionVersionModel | null = null
  transaction: LicensesCollectionTransactionModel | null = null
  versionId = ''
  note = ''
  demo = false
}

export class LicensesModel {
  parameters: LicensesParametersModel = new LicensesParametersModel()
  collection: LicensesCollectionModel[] = []
}

export class FilterCollectionModel {
  typeId?: string = ''
  propertyId?: string = ''
  filter?: unknown | null = null
}
export class FiltersCollectionModel {
  filters?: FilterCollectionModel = []
  pageSize?: number | null = null
  pageNumber?: number | null = null
  join?: string = ''
  order?: string = ''
  orderBy?: string = ''
}

export class SerialNumberRequestModel extends CustomerModel {
  serialNumber = ''
  countryCode?: string = ''
}

export class ByDeviceSerialRequestModel extends CustomerModel {
  deviceSerial = ''
  licenseVersionId = ''
  countryCode?: string = ''
}

export class ByDiscountCodeRequestModel extends CustomerModel {
  deviceSerial = ''
  discountCode = ''
  timePeriodId = ''
  licenseVersionId?: string = ''
  countryCode?: string = ''
}

export class NewLicenseModel extends CustomerModel {
  deviceSerial = ''
  discountCode = ''
  timePeriodId = ''
  licenseVersionId?: string = ''
  countryCode?: string = ''
  createdByDg?: boolean = false
  licenseId?: string = ''
}

export enum SuccessType {
  SUCCESS_NEW = 'SUCCESS_NEW',
  SUCCESS_RENEW = 'SUCCESS_RENEW',
}

export class SyncLicenseModel {
  synccompanyid? = true
  syncexpirationdate? = true
}

export class SyncResellersModel {
  syncreseller? = true
}

export class SyncExternalServiceModel {
  syncexternalservice? = true
}

export class SyncCompanyListModel {
  synclicenses? = true
}

export class CompanystatisticModel {
  id = ''
  date: Date | string = ''
  dtM8 = 0
  dtM7 = 0
  expiredDTM8 = 0
  expiredDTM7 = 0
  demoDTM8 = 0
  demoDTM7 = 0
  advProDTM8 = 0
  alltechDTM8 = 0
  icdtM8 = 0
  advDTM7 = 0
  proDTM7 = 0
  icdtM7 = 0
  alltechDTM7 = 0
}

export class LicensesByCustomerEmailModel {
  id = ''
  name = ''
  sequentialId = 0
  serialNumber = ''
  customerName = ''
  customerSurname = ''
  customerEmail = ''
  customerPhone = ''
  customerAddress = ''
  customerFarm = ''
  note = ''
  companyCode = ''
  countryCode = ''
  activationDate: Date | string = ''
  expirationDate: Date | string = ''
  product = {
    id: '',
    name: '',
    deleted: false,
  }
  productId = ''
  user = {
    id: '',
    resellerId: '',
    reseller: {
      id: '',
      name: '',
      type: {
        id: '',
        name: '',
      },
      typeId: '',
      delete: false,
    },
    name: '',
    lastName: '',
    countryCodeId: '',
    companyName: '',
    companyAddress: '',
    companyTown: '',
    zipCode: '',
    telephone: '',
    mobileTelephone: '',
    department: '',
    vat: '',
    sdi: '',
    email: '',
    emailConfirmed: false,
    eulaAccepted: false,
    currencyId: '',
    currency: {
      id: '',
      name: '',
      symbol: '',
      coinDigits: 0,
    },
    lastAccessedAt: Date,
    createdAt: Date,
    note: '',
    deleted: false,
  }
  userId = ''
  resellerId = ''
  reseller = {
    id: '',
    name: '',
    type: {
      id: '',
      name: '',
    },
    typeId: '',
    deleted: false,
  }
  versionId = ''
  version = {
    id: '',
    name: '',
  }
  transactionId = ''
  transaction = {
    id: '',
    usedDiscountCode: '',
    userEmail: '',
    customerEmail: '',
    transactionDate: Date,
    licenseExpirationDate: Date,
  }
  stateId = ''
  deleted = false
  demo = false
}
